import { createStyles } from '@mui/material';
import { makeStyles } from '../../../../../styles';
export default (theme) => createStyles({
    container: {
        display: 'none',
        position: 'absolute',
        left: 0,
        top: 0,
        background: theme.colors.primary.contrastWhite,
        zIndex: 999,
        boxSizing: 'border-box',
    },
    select: {
        width: '100% !important',
        height: '100%',
        fontFamily: 'Source Sans Pro, sans-serif',
        '& div.MuiBox-root': {
            marginBottom: 0,
        },
        '& [class$="container"]': {
            height: '100%',
        },
        '& [class$="control"]': {
            minHeight: 'auto',
            height: '100%',
            border: 0,
            overflow: 'hidden',
            '& > div': {
                flexWrap: 'nowrap',
                minWidth: 'fit-content',
            },
        },
    },
});
export const useStyles = makeStyles((theme) => ({
    chip: {
        '&.MuiChip-root': {
            height: `${theme.spacing(3)}`,
            borderRadius: `${theme.spacing(0.5)}`,
            margin: `0 ${theme.spacing(0.5)}`,
            backgroundColor: theme.colors.gray[100],
            border: `1px solid ${theme.colors.gray[200]}`,
            color: theme.colors.text[900],
        },
    },
}));
//# sourceMappingURL=SpreadsheetInputSelect.styles.js.map